// AUTO-GENERATED by chomp/processing/generateSetupCPU.py. Do not edit by hand.
// Source: chomp/script/cpu-teams.json

export const CPU_TEAMS: readonly (readonly number[])[] = [
  [14, 12, 11, 1], // Mulong, Nirvamma, Ekineki, Inutia
  [0, 5, 8, 9], // Ghouliath, Sofabbi, Volthare, Aurox
  [2, 6, 10, 13], // Malalien, Pengym, Xmon, Glob
] as const;
